module.exports = __webpack_public_path__ + "img/kingfisher.8901a2aa.jpg";